// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  height: 100%;
}

.loaderLogo {
  position: absolute;
  opacity: 0.1;
  width: 50vw;
  margin: auto;
  margin-right: 7px;
}

.loader-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0b0b0b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.lds-ripple-large {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple-large div {
  position: absolute;
  border: 4px solid #48CAE4;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple-large 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple-large div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple-large {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
.lds-ripple-medium {
  display: inline-block;
  position: relative;
  width: 40px;
  height: 40px;
}

.lds-ripple-medium div {
  position: absolute;
  border: 4px solid #48CAE4;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple-medium 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple-medium div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple-medium {
  0% {
    top: 18px;
    left: 18px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 36px;
    height: 36px;
    opacity: 0;
  }
}
.localRippleContainer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Components/LoadingSpinner/LoadingSpinner.scss"],"names":[],"mappings":"AACE;EACE,SAAA;EACA,UAAA;EACA,YAAA;AAAJ;;AAGE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAAJ;;AAGE;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAEE;EACE,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,oEAAA;AACJ;;AACE;EACE,sBAAA;AAEJ;;AAAE;EACE;IACE,SAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;EAGJ;EADE;IACE,QAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EAGJ;AACF;AAAE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAEJ;;AAAE;EACE,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,qEAAA;AAGJ;;AADE;EACE,sBAAA;AAIJ;;AAFE;EACE;IACE,SAAA;IACA,UAAA;IACA,QAAA;IACA,SAAA;IACA,UAAA;EAKJ;EAHE;IACE,QAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EAKJ;AACF;AAFA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAIF","sourcesContent":["\r\n  body {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 100%;\r\n  }\r\n\r\n  .loaderLogo {\r\n    position: absolute;\r\n    opacity: 0.1;\r\n    width: 50vw;\r\n    margin: auto;\r\n    margin-right: 7px;\r\n  }\r\n\r\n  .loader-wrapper {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    background-color: #0b0b0b;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n.lds-ripple-large {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 80px;\r\n    height: 80px;\r\n  }\r\n  .lds-ripple-large div {\r\n    position: absolute;\r\n    border: 4px solid #48CAE4;\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n    animation: lds-ripple-large 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\r\n  }\r\n  .lds-ripple-large div:nth-child(2) {\r\n    animation-delay: -0.5s;\r\n  }\r\n  @keyframes lds-ripple-large {\r\n    0% {\r\n      top: 36px;\r\n      left: 36px;\r\n      width: 0;\r\n      height: 0;\r\n      opacity: 1;\r\n    }\r\n    100% {\r\n      top: 0px;\r\n      left: 0px;\r\n      width: 72px;\r\n      height: 72px;\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n  .lds-ripple-medium {\r\n    display: inline-block;\r\n    position: relative;\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n  .lds-ripple-medium div {\r\n    position: absolute;\r\n    border: 4px solid #48CAE4;\r\n    opacity: 1;\r\n    border-radius: 50%;\r\n    animation: lds-ripple-medium 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\r\n  }\r\n  .lds-ripple-medium div:nth-child(2) {\r\n    animation-delay: -0.5s;\r\n  }\r\n  @keyframes lds-ripple-medium {\r\n    0% {\r\n      top: 18px;\r\n      left: 18px;\r\n      width: 0;\r\n      height: 0;\r\n      opacity: 1;\r\n    }\r\n    100% {\r\n      top: 0px;\r\n      left: 0px;\r\n      width: 36px;\r\n      height: 36px;\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n.localRippleContainer {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
